import { Injectable, Renderer2, RendererFactory2, WritableSignal, signal, inject } from '@angular/core';

import { SsrService } from '@services/ssr.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private rendererFactory = inject(RendererFactory2);
  private ssrService = inject(SsrService);
  public heroHeaderHeight: WritableSignal<number> = signal(0);
  private renderer: Renderer2;

  disableScroll(name?: string): void {
    const className = 'html--scroll-disabled' + (name ? '-' + name : '');
    this.renderer.addClass(this.ssrService.getDocument().documentElement, className);
  }

  enableScroll(name?: string): void {
    const className = 'html--scroll-disabled' + (name ? '-' + name : '');
    this.renderer.removeClass(this.ssrService.getDocument().documentElement, className);
  }

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }
}
